export var TabNames;
(function (TabNames) {
    TabNames[TabNames["NONE"] = 0] = "NONE";
    TabNames[TabNames["DESIGNS"] = 1] = "DESIGNS";
    TabNames[TabNames["COLORS"] = 2] = "COLORS";
    TabNames[TabNames["TEXT"] = 3] = "TEXT";
    TabNames[TabNames["LOGO"] = 4] = "LOGO";
})(TabNames || (TabNames = {}));
export class TabData {
    constructor(id, name, textID) {
        this.id = id;
        this.textID = textID;
        this.name = name;
    }
}
export default [
    new TabData(TabNames.DESIGNS, "DESIGNS", 'konf_Design'),
    new TabData(TabNames.COLORS, "COLORS", 'konf_Farben'),
    new TabData(TabNames.TEXT, "TEXT", 'konf_Text'),
    new TabData(TabNames.LOGO, "LOGO", 'konf_Logo'),
];
//# sourceMappingURL=tabs.js.map